module.exports = __webpack_public_path__ + "img/icon_box_1_3.a9d6b83a.png";